import React from "react";
import LogoMarquee from "../LogoMarquee";

const CLIENT_LOGOS = [
  { src: "/logos/tightwell.png", alt: "Tightwell Fasteners" },
  { src: "/logos/unitech.png", alt: "Unitech Gears" },
  { src: "/logos/greenfab.png", alt: "GreenFab Industries" },
  { src: "/logos/steelworks.png", alt: "SteelWorks India" },
  { src: "/logos/machinex.png", alt: "Machinex Pvt Ltd" },
];

const TrustedBy = () => (
  <section className="trusted">
    <p className="trusted__label">Trusted by growing teams across India</p>
    <LogoMarquee logos={CLIENT_LOGOS} speed={28} />
  </section>
);

export default TrustedBy;
